import React, { useState, useEffect } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Doughnut } from "react-chartjs-2";
import Web3 from "web3";
import axios from "axios";
import {
  fetchEth,
  fetchCondo,
  fetchAurusX,
  fetchCoinDetail,
  fetchIndexCoopDetail,
} from "../../../utils/services/api";
import { polytradeABI } from "../../../utils/constant/abi";
import { mapleABI } from "../../../utils/constant/abi";
import { brickkenABI } from "../../../utils/constant/abi";
import { indexCoopABI } from "../../../utils/constant/abi";
import { usdcABI } from "../../../utils/constant/abi";
import {
  polytradeAddress,
  condoPolygonTreasury,
} from "../../../utils/constant/contractAddress";
import "./InvestmentsTreasury.css";
import ReactApexChart from "react-apexcharts";
import Piechart from "./Piechart";
export const datum = {
  datasets: [
    {
      data: [0, 22, 13, 2],
      backgroundColor: ["rgb(255, 85, 0)", "#7ccafd", "#7ccafd", "#7ccafd"],
    },
  ],
};

const tokens = [
  {
    logo: "https://cryptologos.cc/logos/ethereum-eth-logo.png",
    contractAddress: "0x0000000000000000000000000000000000000000",
    name: "Ethereum",
    symbol: "ETH",
    tokenBalance: 18,
    balance: 0,
    convertedBalance: 0,
  },
  // {
  //   logo: "logo",
  //   contractAddress: "0x4200000000000000000000000000000000000006",
  //   name: "Wrapped Ether",
  //   symbol: "WETH",
  //   tokenBalance: 18,
  //   balance: 0,
  // },
  {
    logo: "logo",
    contractAddress: "0x30d19fb77c3ee5cfa97f73d72c6a1e509fa06aef",
    name: "CONDO",
    symbol: "CONDO",
    tokenBalance: 9,
    balance: 0,
    convertedBalance: 0,
  },
  // {
  //   logo: "logo",
  //   contractAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
  //   name: "USD Coin",
  //   symbol: "USDC",
  //   tokenBalance: 6,
  //   balance: 0,
  // },
  // {
  //   logo: "",
  //   contractAddress: "0x0000000000000000000000000000000000000000",
  //   name: "AurusX",
  //   symbol: "AX",
  //   tokenBalance: 18,
  //   balance: 25417,
  //   convertedBalance: 0,
  // },
  {
    logo: "",
    contractAddress: { polytradeAddress },
    name: "Polytrade",
    symbol: "TRADE",
    tokenBalance: 0,
    balance: 0,
    convertedBalance: 0,
  },
  {
    logo: "",
    contractAddress: "0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66",

    name: "Syrup",
    symbol: "SYRUP",
    tokenBalance: 0,
    balance: 0,
    convertedBalance: 0,
  },
  {
    logo: "",
    // contractAddress: "",
    contractAddress: "0x0e28bC9B03971E95acF9ae1326E51ecF9C55B498",
    name: "Brickken",
    symbol: "BKN",
    tokenBalance: 0,
    balance: 0,
    convertedBalance: 0,
  },
  {
    logo: "",
    // contractAddress: "",
    contractAddress: "0xC884646E6C88d9b172a23051b38B0732Cc3E35a6",
    name: "Index Coop Ethereum 2x Index",
    symbol: "ETH2X",
    tokenBalance: 0,
    balance: 0,
    convertedBalance: 0,
  },
  {
    logo: "",
    // contractAddress: "",
    contractAddress: "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
    name: "USDC",
    symbol: "USDC",
    tokenBalance: 0,
    balance: 0,
    convertedBalance: 0,
  },
];

const options = {
  chart: {
    width: 380,
    type: "pie",
  },
  labels: [
    "Ethereum",
    "Condo",

    "Polytrade",
    "Syrup",
    "Brickken",
    "Index coop ethereum 2x",
    "USDC",
  ],
  // colors: ["#7cb5ec", "#5891c8", "#346da4", "#0f4a7f"],
  colors: [
    "#a0d9ff",
    "#79b8e1",
    "#7cb5ec",
    "#5891c8",
    "#61a7e8",
    "#346da4",
    "#0f4a7f",
    // "#053259",
  ],
  // #0f4a7f", "#346da4", "#5891c8" #7cb5ec,#79b8e1, #c4fdff
  responsive: [
    {
      breakpoint: 480,
      options: {
        chart: {
          width: 320,
        },
        legend: {
          position: "bottom",
        },
      },
    },
  ],
};

const InvestmentsTreasury = () => {
  const mapleContract = "0x33349B282065b0284d756F0577FB39c158F935e6";
  const syrupContract = "0x643C4E15d7d62Ad0aBeC4a9BD4b001aA3Ef52d66";
  const brickkenContract = "0x0e28bC9B03971E95acF9ae1326E51ecF9C55B498";
  const indexCoopContract = "0xC884646E6C88d9b172a23051b38B0732Cc3E35a6";
  const usdcContract = "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
  const condobasecontractAddress = "0x6404B20B5a8493c426b6efBE52809B206b26d393";
  const url =
    "https://base-mainnet.g.alchemy.com/v2/AVp50h8nie8CF4LhvSjATb8_zEi3TLIE";
  const urlPolygon =
    "https://polygon-mainnet.g.alchemy.com/v2/AVp50h8nie8CF4LhvSjATb8_zEi3TLIE";

  const urlMaple =
    "https://eth-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4";

  const urlBrickken =
    "https://bnb-mainnet.g.alchemy.com/v2/H1rJyGFx5Lny_Lu9ALavFSjD9fEpReZ4";

  const [activeTab, setActiveTab] = useState("cryptoassets");
  const [tableData, setTableData] = useState(tokens);
  const [pieChart, setPieChart] = useState([]);
  const [mapleBal, setMapleBal] = useState(null);
  const [totalMaple, setTotalMaple] = useState(null);
  const [tradeBal, setTradeBal] = useState({});
  const [brickkenBal, setBrickkenBal] = useState(null);
  const [totalBrickken, setTotalBrickken] = useState(null);
  const [loading, setLoading] = useState(false);
  // const []
  // console.log("tradeBal", tradeBal);
  useEffect(() => {
    (async () => {
      const web3 = new Web3(urlPolygon);
      const polytradeContract = new web3.eth.Contract(
        polytradeABI,
        polytradeAddress
      );
      const balance = await polytradeContract.methods
        .balanceOf(condoPolygonTreasury)
        .call();
      const polyBalance = web3.utils.fromWei(balance, "ether");
      const convertPolyBal = parseFloat(polyBalance);
      // console.log("convertPolyBal", typeof convertPolyBal);
      const polytradeDetail = await fetchCoinDetail("polytrade");
      // console.log("polytradePriceUSD", polytradeDetail.current_price);
      // console.log(
      //   "polytradeBal in usd",
      //   polyBalance * polytradeDetail.current_price
      // );
      setTradeBal((prev) => ({
        ...prev,
        polytradeBal: convertPolyBal,
        polytradeUsd: polyBalance * polytradeDetail.current_price,
      }));
    })();
  }, []);

  //// table data start
  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const web3 = new Web3(new Web3.providers.HttpProvider(url));

        const getBalance = async () => {
          const weiBalance = await web3.eth.getBalance(
            condobasecontractAddress
          );
          return web3.utils.fromWei(weiBalance, "ether");
        };

        const getAllBalance = async () => {
          const resp = await axios.post(url, {
            id: 43,
            jsonrpc: "2.0",
            method: "alchemy_getTokenBalances",
            params: [
              "0x6404B20B5a8493c426b6efBE52809B206b26d393",
              [
                // "0x4200000000000000000000000000000000000006",
                "0x30d19fb77c3ee5cfa97f73d72c6a1e509fa06aef",
                // "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913",
              ],
            ],
          });
          return resp.data.result;
        };

        const getMetaForWETH = async () => {
          const resp = await axios.post(url, {
            id: 44,
            jsonrpc: "2.0",
            method: "alchemy_getTokenMetadata",
            params: ["0x4200000000000000000000000000000000000006"],
          });
          return resp.data;
        };

        const getMetaForUSDC = async () => {
          const resp = await axios.post(url, {
            id: 44,
            jsonrpc: "2.0",
            method: "alchemy_getTokenMetadata",
            params: ["0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913"],
          });
          return resp.data;
        };

        const getMetaForCONDO = async () => {
          const resp = await axios.post(url, {
            id: 44,
            jsonrpc: "2.0",
            method: "alchemy_getTokenMetadata",
            params: ["0x30d19fb77c3ee5cfa97f73d72c6a1e509fa06aef"],
          });
          return resp.data;
        };

        const [balance, allBalance, metaCONDO] = await Promise.all([
          getBalance(),
          getAllBalance(),
          getMetaForCONDO(),
          // getMetaForWETH(),
          getMetaForUSDC(),
        ]);

        let data = [...tableData];

        data[0].balance = parseFloat(balance).toFixed(3);
        const ethUsdRates = await fetchEth();
        data[0].convertedBalance =
          ethUsdRates.current_price * parseFloat(balance).toFixed(3);

        data[1].balance = parseFloat(
          web3.utils.fromWei(allBalance.tokenBalances[0].tokenBalance, "ether")
        ).toLocaleString();
        data[1].logo = metaCONDO.result.logo;
        data[1].tokenBalance = metaCONDO.result.decimals;

        data[1].name = metaCONDO.result.name;
        data[1].symbol = metaCONDO.result.symbol;
        const condoUsdRates = await fetchCondo();

        data[1].convertedBalance =
          condoUsdRates.current_price *
          parseFloat(
            web3.utils.fromWei(
              allBalance.tokenBalances[0].tokenBalance,
              "ether"
            )
          );

        // const aurusxUsdRates = await fetchAurusX();
        // data[2].convertedBalance =
        //   aurusxUsdRates.current_price * data[2].balance;

        /// trade bal
        const webs3 = new Web3(urlPolygon);
        const polytradeContract = new webs3.eth.Contract(
          polytradeABI,
          polytradeAddress
        );
        const pbalance = await polytradeContract.methods
          .balanceOf(condoPolygonTreasury)
          .call();
        const polyBalance = web3.utils.fromWei(pbalance, "ether");
        const convertPolyBal = parseFloat(polyBalance);
        data[2].balance = Number(convertPolyBal.toFixed(3)).toLocaleString();
        const polytradeDetail = await fetchCoinDetail("polytrade");
        data[2].convertedBalance =
          convertPolyBal * polytradeDetail.current_price;

        // maple
        const webs3M = new Web3(urlMaple);
        const mapleContractAdd = new webs3M.eth.Contract(
          mapleABI,
          syrupContract
        );
        const maplebalance = await mapleContractAdd.methods
          .balanceOf(condobasecontractAddress)
          .call();
        const mapleBal = webs3M.utils.fromWei(maplebalance, "ether");
        const convertMapleBal = parseFloat(mapleBal);
        data[3].balance = Number(convertMapleBal.toFixed(3)).toLocaleString();
        const mapleDetail = await fetchCoinDetail("syrup"); // maple
        data[3].convertedBalance = convertMapleBal * mapleDetail.current_price;

        // brickken
        const webs3B = new Web3(urlBrickken);
        const brickkenContractAdd = new webs3B.eth.Contract(
          brickkenABI,
          brickkenContract
        );
        const brickkenBal = await brickkenContractAdd.methods
          .balanceOf(condobasecontractAddress)
          .call();
        const brickkenBl = webs3B.utils.fromWei(brickkenBal, "ether");
        const convertBrickkenBal = parseFloat(brickkenBl);
        data[4].balance = Number(
          convertBrickkenBal.toFixed(3)
        ).toLocaleString();
        const brickkenDetails = await fetchCoinDetail("brickken");
        data[4].convertedBalance =
          convertBrickkenBal * brickkenDetails.current_price;

        // indexCoop
        const webs3C = new Web3(url);
        const indexCoopContractAdd = new webs3C.eth.Contract(
          indexCoopABI,
          indexCoopContract
        );
        const indexCoopBal = await indexCoopContractAdd.methods
          .balanceOf(condobasecontractAddress)
          .call();
        const indexCoopBl = webs3C.utils.fromWei(indexCoopBal, "ether");
        const convertCoopBal = parseFloat(indexCoopBl);
        data[5].balance = Number(convertCoopBal.toFixed(3)).toLocaleString();
        // const indexCoopDetails = await fetchCoinDetail(
        //   "index-coop-ethereum-2x-index"
        // );
        const indexCoopDetails = await fetchIndexCoopDetail();
        data[5].convertedBalance = convertCoopBal * indexCoopDetails;

        // USDC
        // USDC
        const usdcContractAdd = new webs3C.eth.Contract(usdcABI, usdcContract);
        const usdcBal = await usdcContractAdd.methods
          .balanceOf(condobasecontractAddress)
          .call();

        // USDC has 6 decimals
        const usdcBl = Number(usdcBal) / 1e6;
        const convertUSDCBal = parseFloat(usdcBl);

        data[6].balance = Number(convertUSDCBal.toFixed(3)).toLocaleString();

        const usdcBalDetails = (await fetchCoinDetail("usd-coin"))
          .current_price;
        data[6].convertedBalance = convertUSDCBal * usdcBalDetails;

        setTableData(data);

        setPieChart([
          parseFloat(data[0].convertedBalance),
          parseFloat(data[1].convertedBalance),
          parseFloat(data[2].convertedBalance),
          parseFloat(data[3].convertedBalance),
          parseFloat(data[4].convertedBalance),
          parseFloat(data[5].convertedBalance),
          parseFloat(data[6].convertedBalance),
        ]);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    // console.log("tableData", tableData);

    fetchAllData();
  }, []);
  //// table data end

  // const series = [326423.64, 437780.34, 8324.4];
  return (
    <>
      <div className="container poetsen-one-regular mt-5 investmentTreasure treasury-bg">
        <h4 className="mb-4 mt-3">Condo Treasury </h4>
        <Tab.Container
          activeKey={activeTab}
          onSelect={(tab) => setActiveTab(tab)}
        >
          <Nav variant="tabs" className="">
            <Nav.Item>
              <Nav.Link eventKey="cryptoassets">Crypto Assets</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="ventureinvestment">
                Venture Investments
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="cash">Cash</Nav.Link>
            </Nav.Item>{" "}
            {/* <Nav.Item>
            <Nav.Link eventKey="liquidcryptoassets">
              Liquid Crypto Assets
            </Nav.Link>
          </Nav.Item> */}
            <Nav.Item>
              <Nav.Link eventKey="nfts">NFTs</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="cryptoassets" className=" wallet-box">
              {/* <div className="d-flex align-items-center ">
              <Doughnut data={datum} className="pie-chart-width" />
              <div>
                <h4 style={{ marginBottom: "0" }}>$0</h4>
                <p>0% of treasury</p>
              </div>
            </div> */}
              <div className="table-responsive">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Symbol</th>
                      <th>Token Balance</th>
                      <th>Balance</th>
                      {/* <th>ROI %</th>
                    <th>Allocation %</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item.name}</td>
                        <td>{item.symbol}</td>
                        <td>{item?.balance?.toLocaleString()}</td>
                        <td>${item.convertedBalance?.toFixed(2)}</td>
                        {/* <td>{item.roi}</td>
                      <td>{item.allocation}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div
                className="piechart-div"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* <Piechart /> */}
                {pieChart.length > 0 ? (
                  <ReactApexChart
                    options={options}
                    series={pieChart}
                    type="pie"
                    width={600}
                  />
                ) : (
                  <div className="loading-chart-data">
                    Loading Chart Data...
                  </div>
                )}
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="ventureinvestment" className=" wallet-box">
              {/* <div className="d-flex align-items-center ">
              <Doughnut data={datum} className="pie-chart-width" />
              <div>
                <h4 style={{ marginBottom: "0" }}>$0</h4>
                <p>0% of treasury</p>
              </div>
            </div> */}
              <div className="table-responsive">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Category</th>
                      <th>Value</th>
                      <th>Purchase Value</th>
                      <th>ROI %</th>
                      <th>Allocation %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    <tr>
                      <td style={{ color: "grey" }}>No data</td>
                    </tr>
                    {/* {data.ventureinvestment.map((item, index) => (
                    <tr key={index}>
                      <td>{item.asset}</td>
                      <td>{item.category}</td>
                      <td>{item.value}</td>
                      <td>{item.purchaseValue}</td>
                      <td>{item.roi}</td>
                      <td>{item.allocation}</td>
                    </tr>
                  ))} */}
                  </tbody>
                </table>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="cash" className=" wallet-box">
              {/* <div className="d-flex align-items-center ">
              <Doughnut data={datum} className="pie-chart-width" />
              <div>
                <h4 style={{ marginBottom: "0" }}>$0</h4>
                <p>0% of treasury</p>
              </div>
            </div>{" "} */}
              <div className="table-responsive">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Category</th>
                      <th>Value</th>
                      <th>Purchase Value</th>
                      <th>ROI %</th>
                      <th>Allocation %</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ color: "grey" }}>No data</td>
                    </tr>
                    {/* {data.cash.map((item, index) => (
                    <tr key={index}>
                      <td>{item.asset}</td>
                      <td>{item.category}</td>
                      <td>{item.value}</td>
                      <td>{item.purchaseValue}</td>
                      <td>{item.roi}</td>
                      <td>{item.allocation}</td>
                    </tr>
                  ))} */}
                  </tbody>
                </table>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="liquidcryptoassets" className=" wallet-box">
              {/* <div className="d-flex align-items-center ">
              <Doughnut data={datum} className="pie-chart-width" />
              <div>
                <h4 style={{ marginBottom: "0" }}>$0</h4>
                <p>0% of treasury</p>
              </div>
            </div> */}
              <div className="table-responsive">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Category</th>
                      <th>Value</th>
                      <th>Purchase Value</th>
                      <th>ROI %</th>
                      <th>Allocation %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    <tr>
                      <td style={{ color: "grey" }}>No data</td>
                    </tr>
                    {/* {data.liquidcryptoassets.map((item, index) => (
                    <tr key={index}>
                      <td>{item.asset}</td>
                      <td>{item.category}</td>
                      <td>{item.value}</td>
                      <td>{item.purchaseValue}</td>
                      <td>{item.roi}</td>
                      <td>{item.allocation}</td>
                    </tr>
                  ))} */}
                  </tbody>
                </table>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="nfts" className=" wallet-box">
              {/* <div className="d-flex align-items-center ">
              <Doughnut data={datum} className="pie-chart-width" />
              <div>
                <h4 style={{ marginBottom: "0" }}>$0</h4>
                <p>0% of treasury</p>
              </div>
            </div>{" "} */}
              <div className="table-responsive">
                <table className="custom-table">
                  <thead>
                    <tr>
                      <th>Asset</th>
                      <th>Category</th>
                      <th>Value</th>
                      <th>Purchase Value</th>
                      <th>ROI %</th>
                      <th>Allocation %</th>
                    </tr>
                  </thead>
                  <tbody>
                    {" "}
                    <tr>
                      <td style={{ color: "grey" }}>No data</td>
                    </tr>
                    {/* {data.nfts.map((item, index) => (
                    <tr key={index}>
                      <td>{item.asset}</td>
                      <td>{item.category}</td>
                      <td>{item.value}</td>
                      <td>{item.purchaseValue}</td>
                      <td>{item.roi}</td>
                      <td>{item.allocation}</td>
                    </tr>
                  ))} */}
                  </tbody>
                </table>
              </div>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </div>
    </>
  );
};
export default InvestmentsTreasury;
